export enum AppRegistrationSection {
  Intro,
  Identification,
  Confirmation,
  Summary,
}
